<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-07-11 14:11:49
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-07-17 16:13:54
 * @FilePath: \duilvpcbase\src\views\originality\children\createQE\components\updateExtrinsicFactorsNode.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <div class="node-state"
             style="margin-left:1%;margin-bottom:0.5%;margin-top: 0.5%;">
          <div class="item-state"
               style="padding-left: 1%;padding-bottom:0.5%;padding-bottom:0.5%;"
               v-for="radioData of sceneStandardMakeDataArr"
               :key="radioData.nodeName"
               @change="radioChange">
            <span>{{radioData.nodeName}}</span><br>
            <qe-radio-image-upload :src="src"
                                   :isPic="true"
                                   :picImgs="radioData.picArr"
                                   :nodeName="''"
                                   :subNodeName="radioData.nodeName"
                                   @getDataArrPic="getDataArrPic"
                                   style="width: 80%; padding: 20px 0px 0px 0px;">
              <i slot="del"
                 class="del-p"></i>
            </qe-radio-image-upload>
            <template>
              <el-radio-group v-model="radioData.nodeState"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          :label=1>良好</el-radio>
                <el-radio border
                          :label=2>预警</el-radio>
                <el-radio border
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin:0px;">
              <input type="text"
                     placeholder="描述"
                     v-model="radioData.remark" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QeRadioImageUpload from './qeRadioImageUpload.vue'

export default {
  name: 'updateSceneStandardMake',
  props: ['oldSceneStandardMakeDataArr'],
  watch: {
    oldSceneStandardMakeDataArr (newValue) {
      this.sceneStandardMakeDataArr = newValue;
    },
  },
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      type: '',
      //nodeState 1-良好 2-预警 3-异常
      sceneStandardMakeDataArr: this.oldSceneStandardMakeDataArr
    }
  },
  components: {
    QeRadioImageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
    radioChange () {
      this.$emit('getSceneStandardMakeData', this.sceneStandardMakeDataArr);
    },
    getDataArrPic (nodeName, imageName, data) {
      for (let subnode of this.sceneStandardMakeDataArr) {
        if (subnode.nodeName == imageName) {
          subnode.picArr = data
        }
      }
      this.$emit('getSceneStandardMakeData', this.sceneStandardMakeDataArr);
      //console.log("getDataArrPic", "getDataArrPic")
    },
  },
}
</script>

<style scoped>
</style>
